// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"224":"88787404253232fa2a4f","319":"97faa51f5e857c2c3532"}[chunkId] + ".chunk.js";
};